import { useEffect, useState, useRef } from 'react';
import './index.scss'
import { data } from './data';
import { useHistory } from "react-router-dom";
import * as Api from '../../api/common';
import { Carousel } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Modal, Space } from 'antd';
import Const from '../../utils/Const';
const { confirm } = Modal;
/**列表页面 */
interface Props {

}
const Index = (parent: Props) => {
    const history = useHistory();
    // const state: any = history.location.state;//可获取到上面传递的值。
    const selectName = sessionStorage.getItem('selectName');

    const [list, setList]: any = useState([
        { name: "Temp：", value: "27", key: "temp", unit: "℃" },
        { name: "RH：", value: "50", key: "rh", unit: "%" },
        { name: "CH₂O：", value: "0.01", key: "ch2o", unit: "ug/m³" },
        { name: "CO₂：", value: "50", key: "co2", unit: "ppm" },
        { name: "PM2.5：", value: "0.01", key: "pm25", unit: "ug/m³" },
        { name: "TVOC：", value: "0.01", key: "tvoc", unit: "ug/m³" },
    ]);
    const [roomList, setRoomList]: any = useState([
        { name: "谱育科技第三期产品评审会", time: "08:30 ~ 10:00", orderNumber: "1" },
        { name: "谱育科技第三期产品评审会", time: "08:30 ~ 10:00", orderNumber: "2" },
        { name: "谱育科技第三期产品评审会", time: "08:30 ~ 10:00", orderNumber: "3" },
    ]);
    const roomType = {
        1: { name: '进行中', class: '1' },
        2: { name: '未开始', class: '2' },
        3: { name: '已结束', class: '3' },
    }
    const [room, setRoom] = useState<boolean>(false);
    const [roomTime, setRoomTime] = useState<any>(5000);
    const [picList, setPicList] = useState<any>([]);
    const [isModel, setIsModel] = useState<boolean>(false);

    useEffect(() => {
        // console.log(state?.value)
        let resetPage = setInterval(() => {
            let date = new Date();
            let hour: any = date.getHours();
            console.log(hour)
            if (hour === 5 || hour === 1 || hour === 23) {
                window.location.reload();
            }
        }, 1000 * 60 * 50)

        let data: any = sessionStorage.getItem('state')
        let state = { value: JSON.parse(data) }
        console.log(state)
        state?.value && getData(state?.value)
        let time = setInterval(() => {
            state?.value && getData(state?.value)
        }, 1000 * 6)
        return () => {
            clearInterval(time)
            clearInterval(resetPage)
        }
    }, [])

    const toBack = () => {
        Api.getlogout().then((res: any) => {
            if (res.success) {
                sessionStorage.setItem('token', "")
                sessionStorage.setItem('path', '/login')
                history.push(`/login`);
            }
        })
    }

    const getData = (data) => {
        Api.getPadAdInfo(data.id).then((res: any) => {
            console.log(res)
            if (res.success) {
                console.log(res)
                res.data.rotationSecond && setRoomTime(Number(res.data.rotationSecond) * 1000);
                setPicList(res.data?.fileList)
            }
        })
        Api.padAppointmentRecordList(data.roomCode).then((res: any) => {
            console.log(res)
            if (res.success) {
                if (res.data?.list?.length > 0) {
                    // setRoom(true)
                    setRoomList(res.data.list)
                } else {
                    // setRoom(false)
                    // setRoom(true)
                    setRoomList([])
                }
            }
        })
        Api.getlist(data.roomCode).then((res: any) => {
            console.log(res)
            let data = res.data.list[0];
            if (res.success) {
                let info = [...list]
                info.map((e) => {
                    e.value = data[e.key] || '-'
                })
                setList(info)
                setRoom(data.status > 0)
                // setList(res.data.list)
            }
        })
    }

    return <div className="main-content alarmDisposal">
        {isModel && <div className="model-top flex-c-c">
            <div className="model-top-main">
                <div className="info flex-c-c">切换会议室需要重新登录验证，是否确认切换？</div>
                <div className="btn-list">
                    <div className="btn flex-c-c" onClick={() => setIsModel(false)}>取消</div>
                    <div className="btn flex-c-c" onClick={toBack}>确认</div>
                </div>
            </div>
        </div>}
        <div className="tit flex-c-c">
            <span>{selectName}</span>
            <div className="icon flex-c-c" onClick={() => setIsModel(true)}></div>
        </div>
        <div className="content">
            {!room && <>
                <Carousel autoplay autoplaySpeed={roomTime}>
                    {picList ? picList?.map((it, ind) => (
                        <div className='box'>
                            <img className='alarmDisposal-bg' src={it.pictureAddressUrl} alt="" />
                        </div>
                    )) : <img className='alarmDisposal-bg' src={require('../../assets/images/bg1.png')} alt="" />}
                </Carousel>
                <div className="list flex-c-s">
                    {list.map((item, index) => {
                        return (
                            <div className="li" key={index}>
                                <div className="name flex-c-l">{item.name}</div>
                                <div className="value flex-c-l">{item.value}{item.unit}</div>
                            </div>
                        )
                    })}
                </div>
            </>}

            {room && <div className="room">
                <Carousel autoplay autoplaySpeed={roomTime} >
                    {picList ? picList?.map((it, ind) => (
                        <div className='box'>
                            <img className='room-bg' src={it.pictureAddressUrl} alt="" />
                        </div>
                    )) : <img className='room-bg' src={require('../../assets/images/bg2.png')} alt="" />}
                </Carousel>
                <div className="room-box">
                    <div className="room-box-tit flex-c-c">今日会议</div>
                    <div className="room-box-list">
                        {roomList?.map((item, index) => {
                            return (
                                <div className={`li flex-c-s status-${roomType[item.orderNumber].class}`} key={`hy-${index}`}>
                                    <div className="info">
                                        <div className="name flex-c-l">{item.meetingTheme}</div>
                                        <div className="time flex-c-l">时间：{item.startTime}{item.endTime ? "~" + item.endTime : ""}</div>
                                    </div>
                                    <div className="btn flex-c-c">{roomType[item.orderNumber].name}</div>
                                    {/* {item.status ? "进行中" : "待进行"} */}
                                </div>
                            )
                        })}
                    </div>
                    <div className="room-box-valie flex-c-s">
                        {list.map((item, index) => {
                            return (
                                <div className="li flex-c-l" key={`zb-${index}`}>
                                    <div className="name flex-c-l">{item.name}</div>
                                    <div className="value flex-c-l">{item.value}{item.unit}</div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>}

        </div>
    </div>
}
export default Index
